import * as React from "react";
import BasePageStyles from "../shared/Styling/BasePageStyling";
import HeroArea, { HeroAreaVariant } from "../shared/BasePage/HeroArea";
import { Container, makeStyles } from "@material-ui/core";
import TracercoButton from "../shared/TracercoButton";
import HeroImage from "../../assets/headers/rigThinCompressed.jpg";

const useStyles = makeStyles(theme => ({
    buttons: {
        padding: theme.spacing(4, 8, 4),
        margin: theme.spacing(4)
    }
}));

interface IPageContents {
    title: string;
    subtitle: string;
    isForbidden: boolean;
    variant?: HeroAreaVariant;
    maxWidth?: "xs" | "sm" | "md" | "lg" | "xl" | false;
}

const PageContents: React.FC<IPageContents> = ({
    title,
    subtitle,
    isForbidden,
    children,
    variant,
    maxWidth
}) => {
    const classes = BasePageStyles();
    const buttonClasses = useStyles();

    const child = children ?? <></>;

    const maximumWidth = maxWidth ?? "lg";

    return (
        <main className={classes.main}>
            {isForbidden ? (
                <>
                    <HeroArea
                        imageUri={HeroImage}
                        title="We're sorry."
                        subtitle="You don't seem to have access to this."
                        variant={variant}
                    />
                    <Container
                        component="section"
                        className={classes.mainContent}
                        maxWidth={maximumWidth}
                    >
                        <TracercoButton
                            className={buttonClasses.buttons}
                            onClick={() => (window.location.href = "/")}
                        >
                            Return to homepage
                        </TracercoButton>
                    </Container>
                </>
            ) : (
                <>
                    <HeroArea
                        imageUri={HeroImage}
                        title={title}
                        subtitle={subtitle}
                        variant={variant}
                    />
                    <Container
                        component="section"
                        className={classes.mainContent}
                        maxWidth={maximumWidth}
                    >
                        {child}
                    </Container>
                </>
            )}
        </main>
    );
};

export default PageContents;
